export const numPattern = /\D/g;

export const meterTextPattern =
  // eslint-disable-next-line no-useless-escape
  /^[а-яА-Яa-zA-Z0-9 +_@.,#®\/\\|<>\(\)\[\]"\*\-]*$/;
